import type { ContractRecordMap } from '@libs/data-access/entities'
import { Alert } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { membershipsSelectors } from '@spa/scenes/Plannings/redux/selectors'
import { keyBy } from 'lodash-es'
import type { FC } from 'react'

type Props = {
  contracts: ContractRecordMap
  selectedContracts?: string[]
}
const CreationWillDeleteShifts: FC<Props> = ({
  selectedContracts = [],
  contracts
}) => {
  const { t } = usePlanningFormTranslation()
  const isMultiContract = selectedContracts?.length > 1
  const contractById = keyBy(contracts.toArray(), 'id')
  const [firstContract] = selectedContracts
  const membership = membershipsSelectors.useGetCachedById(
    contractById[firstContract].membership_id
  )

  if (!isMultiContract) {
    return (
      <Alert
        intent='semantic.red'
        title={
          <div>
            {t('restForm.errorDeleteShift')}
            <span>
              {t('common.app:models.fullname', {
                value: {
                  firstname: membership?.firstname,
                  lastname: membership?.lastname
                }
              })}
            </span>
            .
          </div>
        }
      />
    )
  }

  if (isMultiContract) {
    return (
      <Alert intent='semantic.red' title={t('restForm.errorDeleteShiftMulti')}>
        {selectedContracts.map(id => (
          <div className='m-2 font-semibold text-semantic-red-500' key={id}>
            {t('restForm.listedContractFullname', {
              value: {
                firstname: membershipsSelectors.useGetCachedById(
                  contractById[id].membership_id
                )?.firstname,
                lastname: membershipsSelectors.useGetCachedById(
                  contractById[id].membership_id
                )?.lastname
              }
            })}
          </div>
        ))}
      </Alert>
    )
  }
}

export default CreationWillDeleteShifts
